class Token {

	/**
	 * Create the token.
	 *
	 * @param {string} type The type of token.
	 * @param {any} arg The argument(s).
	 * @return {void}
	 */
	constructor( type, arg = null ) {

		this.type = type;
		this.arg = this.parseArg( arg );
		this.commands = [];

	}


	/**
	 * Add a command to the current token.
	 *
	 * @param {object} token The command to add.
	 * @return {void}
	 */
	addCommandToken( token ) {

		if ( token ) {
			this.commands.push( token );
		}

	}


	/**
	 * Sanitize the arguments.
	 *
	 * @param {any} arg The argument to sanitize.
	 * @return {any}
	 */
	parseArg( arg ) {

		if ( !arg || arg[ 0 ] === '#' ) {
			return arg;
		}

		switch ( typeof arg ) {

			case 'number':
				return parseFloat( arg, 10 );

			case 'object':
				Object.keys( arg ).forEach(
					( key ) => {
						arg[ key ] = this.parseArg( arg[ key ] );
					}
				);
				return arg;

			case 'array':
				arg.forEach(
					( key ) => {
						arg[ key ] = this.parseArg( arg[ key ] );
					}
				);
				return arg;

			default:
				return arg.replace( /[^a-zA-Z 0-9\-\$#]+/g, '' );

		}

	}

}

// let token1 = new Token( 't', 1 );
// console.log( token1.parseArg( 1 ) );
// console.log( token1.parseArg( 1.111234 ) );
// console.log( token1.parseArg( 'test' ) );
// console.log( token1.parseArg( '#fff' ) );
// console.log( token1.parseArg( '!!!exclame' ) );
// console.log( token1.parseArg( [ '!!!exclame', 1, '#fff' ] ) );
// console.log( token1.parseArg( { a: '!!!exclame', b: 1, c: '#fff' } ) );
